import { createSelector } from "reselect";

const selectSlice = (state) => state.ContractStats || {};

export const selectContractStats = createSelector(selectSlice, (s) => s.data);
export const selectContractStatsLoading = createSelector(selectSlice, (s) => s.loading || false);
